// A tiny hub to share the "current controller" across components
let current = null;

export function newController() {
  // Always create a fresh controller for each new request
  current = new AbortController();
  return current;
}

export function getSignal() {
  return current?.signal;
}

export function abortCurrent() {
  if (current) {
    current.abort();
    current = null;
  }
}
